
import { Poster } from './Poster';
import { Select } from './Select';

export const Module1 = (props) => { 
  
  return ( 
    <>
    <div className="fetcher">
      <div className="header">
      <div className="headline">
        <i className="fas fa-cog"></i>Module 1
      </div>
        <div className="right">
        <Select placeholder="Select..." options={['Item 1', 'Item 2', 'Item 3']} />
        <i className="fa-solid fa-clock"></i>00:00:00
        </div>
      </div>
      <div className="body mod1">
        <h1>Lorem ipsum <span className="orange">dolor</span></h1>
        <div className="flexrow">
        <Poster 
          header="Consectetur adipiscing elit"
          icon="fas fa-cube"
          body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris 
          nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
          culpa qui officia deserunt mollit anim id est laborum." 
        />
        <Poster 
          header="Consectetur adipiscing elit"
          icon="fas fa-code"
          body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris 
          nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
          culpa qui officia deserunt mollit anim id est laborum." 
        />
        </div>
        <div className="flexrow height100">
        <Poster 
          header="Consectetur adipiscing elit"
          icon="fas fa-server"
          body="Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
          sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris 
          nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
          culpa qui officia deserunt mollit anim id est laborum."
        />

        </div>

      </div>
      <div className="footer">
        Status
        <div className="right">
        <i className="fa-sharp fa-solid fa-circle"></i>
        All processes running
        </div>
      </div>
    </div>
    </>
  ); 
  
} 

